// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1EJeK","form":"styles_form__1mc9C"};